import React  from 'react';
import logComponent from '../../common/logComponent';

export default function CardContent({ children }) {
  if (logComponent('CardContent')) { console.debug('CardContent rendered'); }
  return (
    <div className="Card__content" >
      {children }
    </div>
  );
}